export default "__VITE_ASSET__CY7lvpd0__"